module.exports = __webpack_public_path__ + "static/img/9.6fb8563.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/sp/9.png
// module id = 7Skm
// module chunks = 0